/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState("verifying"); // verifying | success | error
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setState("error");
      setErrorMsg("Missing verification token.");
      return;
    }
    api.post("/auth/verify-email", { token })
      .then(async () => {
        setState("success");
        try { await refresh(); } catch {}
        setTimeout(() => navigate("/dashboard"), 1500);
      })
      .catch((e) => {
        setState("error");
        setErrorMsg(e?.response?.data?.detail || "Verification failed.");
      });
  }, []);

  return (
    <Layout>
      <section className="max-w-md mx-auto px-6 py-20 text-center" data-testid="verify-email-page">
        {state === "verifying" && (
          <>
            <Loader2 className="w-10 h-10 mx-auto text-[var(--rg-sage)] animate-spin mb-4" />
            <h1 className="font-heading font-bold text-2xl text-[var(--rg-text-strong)]">Verifying your email…</h1>
          </>
        )}
        {state === "success" && (
          <>
            <CheckCircle2 className="w-12 h-12 mx-auto text-[var(--rg-sage)] mb-4" />
            <h1 className="font-heading font-bold text-2xl text-[var(--rg-text-strong)] mb-2">Email verified!</h1>
            <p className="text-[var(--rg-text)] text-sm">Redirecting to your dashboard…</p>
          </>
        )}
        {state === "error" && (
          <>
            <AlertCircle className="w-12 h-12 mx-auto text-[var(--rg-red)] mb-4" />
            <h1 className="font-heading font-bold text-2xl text-[var(--rg-text-strong)] mb-2">Verification failed</h1>
            <p className="text-[var(--rg-text)] text-sm mb-6" data-testid="verify-email-error">{errorMsg}</p>
            <Link to="/dashboard">
              <Button className="bg-[var(--rg-sage)] text-[var(--rg-on-sage)] hover:bg-[var(--rg-sage-hover)] font-semibold">Go to dashboard</Button>
            </Link>
          </>
        )}
      </section>
    </Layout>
  );
}
